import { Pipe, PipeTransform } from '@angular/core';
import { MissionType } from '../../models/mission/mission-type';

@Pipe({
	name: 'filterMissionTypeByType'
})
export class FilterMissionTypeByTypePipe implements PipeTransform {
	transform(types: MissionType[], filter: string): MissionType[] {
		if (types === null || filter === null || filter === '') {
			return types;
		}

		return types.filter((type: MissionType) => {
			if (type.type !== null) {
				return type.type.toLowerCase().includes(filter.toLowerCase());
			}
			return false;
		});
	}
}
